// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"ae5815eb","787":"f338f33c"}[chunkId] + ".chunk.js";
};